import React, {useState} from "react";
import {IconArrowBackUp, IconDeviceFloppy, IconEyeCog, IconRecycle, IconSettings, IconSparkles, IconX} from "@tabler/icons-react";
import PrinterIcon from "../../../../icons/PrinterIcon";
import {UserCRUDRecord} from "@commons/mapping/UserCRUDRecord";
import {useAppSelector} from "@hooks/redux-hooks/hooks";
import {selectUser} from "@commons/core.slice";
import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {StatoGM} from "../calendario.GestionePLUS";
import classNames from "classnames";
import {ConfirmCancel, InfoModal} from "@components/ConfirmModal";

interface PulsantieraProps {
    onClickEye: () => void,
    hasDaysToSave: boolean,
    daysForGM: PresenzeGiornataPlusRecord[],
    setDaysForGM: React.Dispatch<React.SetStateAction<PresenzeGiornataPlusRecord[]>>,
    statoGM: StatoGM,
    setStatoGM: React.Dispatch<React.SetStateAction<StatoGM>>,
    stampaPeriodo: () => void,
    calcolaPeriodo: () => void,
    salvaPeriodo: () => void,
    ripristinaPeriodo: () => void,
}

const PulsantieraCalendarioGestionePLUS: React.FC<PulsantieraProps> = ({
                                                                           onClickEye,
                                                                           hasDaysToSave,
                                                                           daysForGM,
                                                                           setDaysForGM,
                                                                           statoGM,
                                                                           setStatoGM,
                                                                           stampaPeriodo,
                                                                           calcolaPeriodo,
                                                                           salvaPeriodo,
                                                                           ripristinaPeriodo,
                                                                       }) => {
    const [isOpenConfirm, setIsOpenConfirm] = useState(false);
    const [isOpenInfo, setIsOpenInfo] = useState(false);

    const user: UserCRUDRecord | null = useAppSelector(selectUser); // User corrente

    const classContainerBtn = 'inline-flex space-x-2.5';
    const iconClass = 'h-4 w-4 sm:h-5 sm:w-5';
    const btnClass = 'btnPrimary !px-1 max-[715px]:text-xs';

    const isGMAvviata = statoGM !== 'IN_PAUSA';

    return <>
        <div className={classNames("flex flex-col space-y-1 lg:flex-row lg:space-y-0 lg:w-full lg:justify-between", isGMAvviata && "lg:gap-x-2.5",)}>
            <div className={classContainerBtn}>
                <button className="btnPrimary !px-1.5" onClick={onClickEye} disabled={isGMAvviata}>
                    <IconEyeCog className={iconClass}/>
                </button>

                <button className={btnClass} disabled={isGMAvviata}
                        onClick={() => {
                            if (hasDaysToSave) {
                                setIsOpenInfo(true);
                            } else {
                                calcolaPeriodo();
                            }
                        }}>
                    <IconSettings className={iconClass}/>&nbsp;Calcola periodo
                </button>

                <button className={btnClass} disabled={isGMAvviata}
                        onClick={() => {
                            if (hasDaysToSave) {
                                setIsOpenInfo(true);
                            } else {
                                setStatoGM('IN_SELEZIONE');
                            }
                        }}>
                    <IconSparkles className={iconClass}/>&nbsp;Giustificazione di massa
                </button>

                {isGMAvviata && <>
                    <button className={btnClass} disabled={daysForGM.length <= 1} onClick={() => {
                        setStatoGM('AVVIATA');
                    }}>
                        <IconRecycle className={iconClass}/>&nbsp;Applica GM
                    </button>
                    <button className={btnClass} type="button" onClick={() => {
                        // Pulisco array di giorni da giustificare
                        setDaysForGM([]);
                        // chiudo la GM
                        setStatoGM('IN_PAUSA');
                    }}>
                        <IconX className={iconClass}/>Annulla GM
                    </button>
                </>}

                <button className="btnPrimary !px-1.5" disabled={isGMAvviata}
                        onClick={() => {
                            if (hasDaysToSave) {
                                setIsOpenInfo(true);
                            } else {
                                stampaPeriodo();
                            }
                        }}>
                    <PrinterIcon className={iconClass}/>
                </button>

            </div>
            <div className={`${classContainerBtn} mx-auto lg:mx-0`}>
                <button className={btnClass} disabled={isGMAvviata || !hasDaysToSave}
                        onClick={() => salvaPeriodo()}>
                    <IconDeviceFloppy className={iconClass}/>&nbsp;Salva
                </button>
                <button className="btnDanger !px-1 max-[715px]:text-xs" disabled={isGMAvviata || !hasDaysToSave}
                        onClick={() => setIsOpenConfirm(true)}>
                    <IconArrowBackUp className={iconClass}/>&nbsp;Ripristina
                </button>
            </div>
        </div>

        <ConfirmCancel open={isOpenConfirm}
                       onCancel={() => {
                           setIsOpenConfirm(false);
                       }}
                       onConfirm={() => {
                           setIsOpenConfirm(false);
                           ripristinaPeriodo();
                       }}
        />

        <InfoModal open={isOpenInfo}
                   onCancel={() => setIsOpenInfo(false)}
                   children={'Salvare le modifiche effettuate prima di procedere!'}
        />
    </>
}

export default PulsantieraCalendarioGestionePLUS;